import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "page-3",
  class: "page-3"
}

import ResponsiveImage from '../responsive-image.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ResponsiveImage, {
      image: require('./bg.jpg'),
      "image-webp": require('./bg.webp'),
      "mobile-image": require('./bg-m.jpg'),
      "mobile-image-webp": require('./bg-m.webp'),
      "image-h": 2326,
      "image-w": 3840,
      "mobile-image-h": 1599,
      "mobile-image-w": 1170
    }, null, 8, ["image", "image-webp", "mobile-image", "mobile-image-webp"])
  ]))
}
}

})